import { handleErrors } from "../util/api-utils";

export function login(successCallback) {
    fetch("api/Identity/Login")
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function internalLogin(successCallback) {
    fetch("api/InternalIdentity/Login")
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export async function logout(finallyCallback) {
    fetch("/api/Identity/Logout")
        .then(handleErrors)
        .catch(console.error)
        .finally(finallyCallback);
};

export function recompileProfile() {
    fetch("/api/Identity/Recompile", { method: "POST" })
        .then(handleErrors)
        .catch(console.error);
}

export function retrieveIdentityInfo(params, successCallback, errorCallback) {
    const query = new URLSearchParams(params).toString();
    fetch(`api/Identity/RetrieveIdentityInfo?${query}`, {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}